import { DottedDivider } from "@components";
import * as styles from "./styles";

function Row({ props }) {
    const isEven = props.i % 2 === 0;
    const isLast = props.i === props.len - 1;

    function List() {
        return (
            <div className={styles.listContainer}>
                <div className="text-center text-2xl font-bold md:text-left">
                    {props.title}
                </div>
                <div className="mt-4 md:mt-8 md:text-lg">
                    {props.list.map((item) => (
                        <div className="mb-4 flex">
                            <div className={styles.greenBullet}></div>
                            <div className="w-[400px]">{item}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={styles.rowContainer}>
                {isEven && (
                    <div className={styles.listParentDesktop}>
                        <List key={"even"} />
                    </div>
                )}
                {props.bgImg ? (
                    <div className="flex flex-col items-center ">
                        <img
                            className={styles.img}
                            src={props.bgImg}
                            alt="Background"
                        />
                        {props.caption && (
                            <div className={styles.caption}>
                                {props.caption}
                            </div>
                        )}
                    </div>
                ) : (
                    props.img
                )}
                {!isEven && (
                    <div className={styles.listParentDesktop}>
                        <List key={"odd"} />
                    </div>
                )}
                <div className={styles.listParentMobile}>
                    <List key={"mobile"} />
                </div>
            </div>
            {!isLast && <DottedDivider className="hidden w-[90%] md:block" />}
        </>
    );
}

export default function Features({ props }) {
    return (
        <div className={styles.parent}>
            <div className={styles.rowsParent}>
                {props.map((feature, i) => (
                    <Row key={i} props={{ ...feature, i, len: props.length }} />
                ))}
            </div>
        </div>
    );
}
